export const style = {
  rangeSliderMark: {
    textAlign: "center",
    color: "#214ff1",
    mt: "5",
    ml: "-6",
    w: "12",
    fontSize: "1rem",
  },
  rangeSliderTrack: {
    bg: "#9ba5f8",
    h: "3px",
  },
  rangeSliderFilledTrack: {
    bg: "#214ff1",
  },
  rangeSliderThumb: {
    boxSize: "20px",
    border: "none",
  },
  box: {
    w: "100%",
    h: "100%",
    borderRadius: "100%",
    border: "2px solid #214ff1",
    bg: "#ffffff",
  },
};